import { createAction } from '../../utils/reduxUtils';
import { ITourDetail, ITourHighlight, ITourInsight, TourCode } from '../../models';
import { IAsyncError, TourRatingListResponse } from '../../common';

const fetchTourRatingsAsync = {
  request: createAction('FETCH_TOUR_RATINGS_REQUEST')<TourCode>,
  success: createAction('FETCH_TOUR_RATINGS_SUCCESS')<TourRatingListResponse>,
  failure: createAction('FETCH_TOUR_RATINGS_FAILURE')<IAsyncError>,
};

const fetchTourDetailsAsync = {
  request: createAction('FETCH_TOUR_DETAIL_REQUEST')<TourCode>,
  success: createAction('FETCH_TOUR_DETAIL_SUCCESS')<ITourDetail>,
  failure: createAction('FETCH_TOUR_DETAIL_FAILURE')<IAsyncError>,
};

const fetchTourInsightAsync = {
  request: createAction('FETCH_TOUR_INSIGHT_REQUEST')<TourCode>,
  success: createAction('FETCH_TOUR_INSIGHT_SUCCESS')<ITourInsight>,
  failure: createAction('FETCH_TOUR_INSIGHT_FAILURE')<IAsyncError>,
};

const fetchTourHighlightsAsync = {
  request: createAction('FETCH_TOUR_HIGHLIGHTS_REQUEST')<TourCode>,
  success: createAction('FETCH_TOUR_HIGHLIGHTS_SUCCESS')<ITourHighlight[]>,
  failure: createAction('FETCH_TOUR_HIGHLIGHTS_FAILURE')<IAsyncError>,
};

const resetTourRating = createAction('RESET_TOUR_RATINGS')<void>;

const actions = {
  fetchTourRatingsAsync,
  resetTourRating,
  fetchTourDetailsAsync,
  fetchTourHighlightsAsync,
  fetchTourInsightAsync,
};

export default actions;
